import Vue from 'vue';

const initialState = () => {
    return {
        addToCartIsLoading: false,
        addToCartError: null,
    }
};

const isTechnicalErrorMessage = (message: string): boolean => {
    return /request failed with status code|network error|timeout of \d+ms exceeded|uri must include|scheme and host|base_uri|guzzlehttp|sqlstate|stack trace|exception|undefined index|class .+ not found/i.test(message);
};

const resolveErrorMessage = (source: any): string | null => {
    if (!source) {
        return null;
    }

    const status = source.response?.status;
    // 5xx and transport failures leak Guzzle/Laravel dumps — never show those.
    if ((typeof status === 'number' && status >= 500) || (source.isAxiosError && !source.response)) {
        return null;
    }

    const apiMessage = source.response?.data?.message || source.data?.message
        || (!source.response && typeof source.message === 'string' ? source.message : null);
    if (typeof apiMessage === 'string' && apiMessage && !isTechnicalErrorMessage(apiMessage)) {
        return apiMessage;
    }

    return null;
};

const isFailedResponse = (data: any): boolean => {
    return Boolean(data && (data.error || data.success === false));
};

const state = initialState();

const actions = {
    async addProductToQuote({commit}, productPayload: object): Promise<void> {
        commit('SET_ADD_TO_CART_LOADING', true);
        commit('SET_ADD_TO_CART_ERROR', null);

        try {
            const {data} = await this.$solarClient.post(
                '/api/quote/item', {
                    cartItem: productPayload,
                }, {timeout: 25000}
            );

            if (isFailedResponse(data)) {
                commit('SET_ADD_TO_CART_ERROR', {
                    message: resolveErrorMessage(data),
                });
                return;
            }

            if (data) {
                window.dispatchEvent(new CustomEvent('CheckoutAddedProductToCartEvent'));
            }
        } catch (error) {
            console.error(error);
            commit('SET_ADD_TO_CART_ERROR', {
                message: resolveErrorMessage(error),
            });
        } finally {
            commit('SET_ADD_TO_CART_LOADING', false);
        }
    }
};

const mutations = {
    SET_ADD_TO_CART_LOADING(state: object, payload: boolean): void {
        Vue.set(state, 'addToCartIsLoading', payload);
    },
    SET_ADD_TO_CART_ERROR(state: object, payload: object): void {
        Vue.set(state, 'addToCartError', payload);
    }
};

const getters = {
    getAddToCartIsLoading: (state: object) => state['addToCartIsLoading'],
    getAddToCartError: (state: object) => state['addToCartError'],
};

const CheckoutQuote = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default CheckoutQuote;
